import { api } from '@frontend/api-utils';
import { AuthenticationManager } from '@frontend/authentication-v2';
import { Logger } from '@frontend/logger';
import { SSOProviderClient } from '@frontend/sso/api';
import { PublicSSOProvider } from '@frontend/sso/types';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { SsoProps } from './sso.component';

interface ViewProps {
    setRedirect: () => void;
    provider: PublicSSOProvider | null;
    url: string | null;
}

const useSso = (props: SsoProps): ViewProps => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const [provider, setProvider] = useState<PublicSSOProvider | null>(null);

    useEffect(() => {
        SSOProviderClient.fetchProviderByDomain()
            .then(setProvider)
            .catch((error) => {
                Logger.warn('No SSO settings found for current domain.', error);
                setProvider(null);
            });
    }, []);

    useEffect(() => {
        const code = params.get('code');
        if (code && provider) {
            const redirectTo = localStorage.getItem('ssoLoginRedirect');
            if (redirectTo) {
                sessionStorage.setItem('preLoginRedirect', redirectTo);
            }
            AuthenticationManager.getInstance()
                .ssoAuthenticate(provider.account_id, provider.id, code)
                .then(() => {
                    if (localStorage.getItem('ssoLoginRedirect')) {
                        const redirectTo = localStorage.getItem('ssoLoginRedirect');
                        localStorage.removeItem('ssoLoginRedirect');
                        if (redirectTo) {
                            navigate(redirectTo);
                        }
                    }
                    props.callback && props.callback();
                });
        }
    }, [params, provider]);

    const setRedirect = () => {
        localStorage.setItem('ssoLoginRedirect', location.pathname + location.search + location.hash);
        AuthenticationManager.getInstance().prepareSsoLogin(props.keepLoggedIn ?? false);
    };

    return {
        setRedirect,
        provider,
        url: provider && api(`/sso-api/v1/accounts/${provider.account_id}/providers/${provider.id}/login`)
    };
};

export default useSso;
